import React, { Component } from 'react'
import { Grid, Row, Col } from 'react-bootstrap'
import { Timeline } from 'react-event-timeline'
import { object, func } from 'prop-types'
import axios from 'axios'
import { connect } from 'react-redux'
import { toastr } from 'react-redux-toastr'
import { uploadFile } from '../utils/uploadFile'

import {
  updateVideo
} from '../actions'

import config from '../config'
import { getAuthToken } from '../utils/sessionStorage'

import WorkflowStep from './WorkflowStep'

class Workflow extends Component {
  constructor (props) {
    super(props)

    this.submit = this.submit.bind(this)
    this.submitCheck = this.submitCheck.bind(this)
    this.submitUpload = this.submitUpload.bind(this)
    this.submitLink = this.submitLink.bind(this)
    this.updateStep = this.updateStep.bind(this)
  }
  submitCheck (id) {
    this.updateStep(id)
  }
  submitUpload (id, file) {
    const { video } = this.props
    if (file) {
      uploadFile(file, video)
        .then((res) => {
          let fileUrl = res
          this.updateStep(id, fileUrl)
        })
    } else {
      toastr.error('Nenhum arquivo para fazer upload')
    }
  }
  submitLink (id, link) {
    this.updateStep(id, link)
  }
  updateStep (id, link) {
    const { video, updateVideo } = this.props
    let url = `${config.url}/campaigns/${video.campaign_id}/videos/${video.id}/workflow/steps/${id}`
    let data = {}
    if (link) {
      data['link'] = link
    }
    axios({
      method: 'PUT',
      url: url,
      headers: {'X-User-Token': getAuthToken()},
      data: data
    })
      .then((res) => {
        let updatedVideo = res.data
        updateVideo(video.campaign_id, updatedVideo)
        toastr.success('Workflow atualizado com sucesso')
      })
      .catch((err) => {
        toastr.error('Ocorreu um erro ao atualizar. Tente novamente')
      })
  }
  submit (id, type, linkOrFile) {
    switch (type) {
      case 'check':
        this.submitCheck(id)
        break
      case 'upload':
        this.submitUpload(id, linkOrFile)
        break
      case 'link':
        this.submitLink(id, linkOrFile)
        break
      default:
        break
    }
  }
  render () {
    const { video } = this.props
    return (
      <Grid>
        <Row>
          <Col md={6} mdOffset={3}>
            <Timeline className='workflow-timeline'>
              {video.workflow.steps.map((step, index) => {
                return <WorkflowStep key={index} step={step} submit={this.submit} />
              })}
            </Timeline>
          </Col>
        </Row>
      </Grid>
    )
  }
}

Workflow.propTypes = {
  video: object,
  updateVideo: func
}

const mapDispatchToProps = (dispatch) => ({
  updateVideo: (campaignId, video) => {
    dispatch(updateVideo(campaignId, video))
  }
})

export default connect(null, mapDispatchToProps)(Workflow)



// WEBPACK FOOTER //
// ./src/components/Workflow.js